<template>
  <div>
    <div class="flex h-full" v-if="sharedSelection && !activeProduct && !activeDecor">
      <div id="side" class="px-10 text-left">
        <div>
          <p class="text-lg pb-2">{{ getTranslation('currentSelection') }}:</p>
          <p class="text-base max-w-full pb-10">{{ sharedSelection.name }}</p>
          <img class="max-w-full" :src="sharedSelection.logo"/>
        </div>
      </div>

      <div id="main" class="mr-10" :class="{'mainLarge':memo, 'mainSmall': !memo}">
        <div id="mainTop" class="pt-5 flex justify-between w-full"
             :class="{'mainTopLarge':memo, 'mainTopSmall': !memo}">
          <div>
            <div class="tabs flex pb-2">
              <p
                class="cursor-pointer border-b-4 pb-2 border-classen__primary text-classen__primary title">
                {{ getTranslation('selection') }} ({{ itemsLoaded }}/{{ total }})
              </p>
            </div>
            <div v-if="memo" class="pb-2 flex memo">{{ memo }}</div>
            <input v-model="searchInput" type="text" :placeholder="getTranslation('search')"
                   class="border-shadow rounded-20 search float-left mt-2 mb-2 pl-2 row-start-2">
          </div>
          <div class="flex">
            <div
              @click="isPopupGenerateExcelVisible = true"
              class="cursor-pointer action_item text-white flex justify-center items-center">
              <img src="../assets/icons/excel.svg" alt="excel">
            </div>
            <div
              @click="isPopupGenerateVisible = true"
              class="cursor-pointer action_item text-white flex justify-center items-center ml-6">
              <img src="../assets/icons/pdf.svg" alt="pdf">
            </div>
          </div>
        </div>
        <div id="mainBottom" class="content-start overflow-y-auto"
             :class="{'mainBottomSmall':memo, 'mainBottomLarge': !memo}">
          <div v-show="isLoaded" v-for="(item, index) in filteredItems" class="">
            <c-product-view :key="index" :displayDelete="false"
                            v-if="getType(item.type) === 'Product'" :product="item.item"
                            :display-quick="false" :selected-selection="null"
            />
            <c-decor-view :key="index" :displayDelete="false"
                          v-if="getType(item.type) === 'Decor'" :decor="item.item"
                          :display-quick="false" :selected-selection="null"
            />
          </div>
          <div class="load_more_div w-full flex justify-center">
            <button v-if="hasMore"
                    class="mt-2 classen__button justify-self-center self-center col"
                    :class="{'hover__button':!isLoadingNextProducts}"
                    @click="loadNextPage">
              <label v-if="!isLoadingNextProducts">{{ getTranslation('loadMoreItems') }}</label>
              <c-loader v-if="isLoadingNextProducts" :inline="true" :bg-blur="false"
                        class="transform scale-50"></c-loader>
            </button>
          </div>
        </div>
      </div>
    </div>
    <c-product-detail id="prod_detail" class="h-full" @close="activeProduct = null"
                      :display-quick-selection="false"
                      :backTo="'backToSelection'"
                      :show-links="false"
                      :product="activeProduct" v-if="activeProduct" :active-selection="null"/>
    <c-decor-detail id="dec_detail" class="h-full" @close="activeDecor = null"
                    :display-quick-selection="false"
                    :backTo="'backToSelection'"
                    :show-links="false"
                    :active-selection="null" :decor="activeDecor" v-if="activeDecor"/>

    <c-generate-excel-popup v-if="isPopupGenerateExcelVisible" :selection="sharedSelection"
                            :selected-options="selectedOptions"
                            @cancel="isPopupGenerateExcelVisible = false"/>

    <c-generate-pdf-popup v-if="isPopupGenerateVisible" @onClose="isPopupGenerateVisible = false"
                          :selected-options="selectedOptions"
                          :selection="sharedSelection"/>
  </div>
</template>

<script>
import Vue from "vue";
import getTranslation from "../mixins/getTranslation";
import ProductView from "../components/structure/Products/ProductView";
import DecorView from "../components/structure/Decors/DecorView";
import ProductDetail from "../components/structure/Products/ProductDetail";
import DecorDetail from "../components/structure/Decors/DecorDetail";
import EventBus from "../services/EventBus";
import GeneratePdfPopup
  from "../components/structure/Selections/actions/GeneratePdf/GeneratePdfPopup";
import GenerateExcelPopup from "../components/structure/Selections/GenerateExcelPopup";
import Loader from "../components/Loader";

export default {
  name: "SharedSelection",

  mixins: [getTranslation],

  components: {
    'c-product-view': ProductView,
    'c-decor-view': DecorView,
    'c-product-detail': ProductDetail,
    'c-decor-detail': DecorDetail,
    'c-generate-excel-popup': GenerateExcelPopup,
    'c-generate-pdf-popup': GeneratePdfPopup,
    'c-loader': Loader,
  },

  created() {
    document.title = 'The Qube - Selection';

    this.$dashboardStore.dispatch('getSharedSelection', this.$route.params.id)
      .then((res) => {
        this.sharedSelection = res.data;
        document.title = `The Qube - ${this.sharedSelection.name}`

        this.$dashboardStore.dispatch('getSharedSelectionItems', {
            sharedSelectionId: this.$route.params.id,
            page: this.page
        })
          .then((res) => {
            let data = {data: res.data};
            Vue.set(this.sharedSelection, 'selectionList', data);
            this.lastPage = res.meta.last_page;
            this.total = res.meta.total;
            this.isLoaded = true;
          })
      });

    this.$dashboardStore.dispatch('getInformationForSharedSelection', this.$route.params.id)
      .then((res) => {
        this.selectedOptions = res.selectedInformation;
        this.memo = res.memo;
      });

    EventBus.listen('set-active_product', this.setActiveProduct)
    EventBus.listen('set-active_decor', this.setActiveDecor)
  },

  destroyed() {
    EventBus.destroy('set-active_product', this.setActiveProduct)
    EventBus.destroy('set-active_decor', this.setActiveDecor)
  },

  data() {
    return {
      sharedSelection: null,
      selectedOptions: [],
      memo: null,
      searchInput: '',
      isLoaded: false,
      activeProduct: null,
      activeDecor: null,
      page: 1,
      lastPage: 1000,
      total: 0,
      isPopupGenerateExcelVisible: false,
      isPopupGenerateVisible: false,
      isLoadingNextProducts: false,
    }
  },

  computed: {
    itemsLoaded() {
      if (!this.sharedSelection.selectionList || !this.sharedSelection.selectionList.data) {
        return 0;
      }

      return this.sharedSelection.selectionList.data.length;
    },

    hasMore() {
      return this.page < this.lastPage;
    },

    filteredItems() {
      if (!this.sharedSelection || !this.sharedSelection.selectionList) {
        return []
      }

      let items = this.sharedSelection.selectionList.data;
      let products = [];
      let decors = [];

      items.forEach((item) => {
        if (this.getType(item.type) === 'Product') {
          products.push(item);
          return
        }

        decors.push(item)
      })

      let itemsSorted = [...products, ...decors]

      if (this.searchInput === '') {
        return itemsSorted
      }

      return items.filter((item) => {
        return item.item.name.toLowerCase().includes(this.searchInput.toLowerCase())
      })
    }
  },

  watch: {},

  methods: {
    loadNextPage() {
      if (this.isLoadingNextProducts) {
        return
      }

      this.isLoadingNextProducts = true;
      this.page++;
      this.$dashboardStore.dispatch('getSharedSelectionItems', {
          sharedSelectionId: this.$route.params.id,
          page: this.page
      })
        .then((res) => {
          Vue.set(this.sharedSelection.selectionList, 'data', [...this.sharedSelection.selectionList.data, ...res.data]);
          this.isLoadingNextProducts = false;
        })
    },

    getType(type) {
      return type.split('\\')[2]
    },

    setActiveProduct(val) {
      this.activeProduct = val
    },

    setActiveDecor(val) {
      this.activeDecor = val
    },
  }
}
</script>

<style scoped>
#side {
  width: 275px;
  padding-top: 70px;
}

.mainSmall {
  width: calc(100% - 300px);
}

.mainLarge {
  width: calc(100% - 275px);
}

.mainTopSmall {
  height: 110px;
}

.mainTopLarge {
  height: 170px;
}

#mainBottom {
  display: grid;
  grid-template-columns: repeat(auto-fill, 300px);
  justify-content: space-between;
  grid-gap: 20px;
}

.mainBottomSmall {
  height: calc(100% - 190px);
}

.mainBottomLarge {
  height: calc(100% - 110px);
}

.action_item {
  height: 50px;
  width: 50px;
  border-radius: 25px;
  background-color: var(--primary);
  line-height: 40px;
  margin-left: 15px;
}

.load_more_div {
  grid-column: 1  / -1;
}

.memo {
  text-align: left;
  white-space: pre-line;
  overflow-y: auto;
  height: 56px;
}
</style>
